import { useEffect, useState } from "react";
import useAutenticar from "./useAutenticar";
import MessageServices from "@services/MessageServices";

export default function PrivateRoute(props) {
  const { handleAutenticar, handleLogout } = useAutenticar();
  const [page, setPage] = useState(null);

  useEffect(() => {
    if (!handleAutenticar()) {
      MessageServices.ShowWarning(
        "Sua sessão expirou. Por favor, faça login novamente!",
      );
      handleLogout();
    } else {
      setPage(props.children);
    }
  }, [props.children]);

  return page;
}
